<template>
    <div class="content registpage">
        <div class="joinuspage">
            <div class="registheader">
                <div class="registlogo"></div>
            </div>
            <div class="registborder"></div>
            <div class="registhead">
                <div class="title ft">프로필 이미지</div>
                <div class="join_profile">
                    <div class="profile_image" v-if="!hasImage()"></div>
                    <div class="profile_image i_size" v-else-if="hasImage()":style="`background-image : url(${dialogImageUrl})`">
                    </div>
                    <el-upload
                            class="avatar-uploader"
                            action=""
                            list-type="picture"
                            :file-list="files"
                            :show-file-list="false"
                            :auto-upload="false"
                            :on-change="onlyOnePhotoChange"
                            :on-remove="handleRemove"
                    >
                        <!--            <el-button class="btn_up" size="small" type="primary">업로드하기</el-button>-->
                        <button class="btn_up" >업로드하기</button>
                    </el-upload>
                    <!--          <el-button class="btn_remove" size="small" type="success" @click="handleRemove()">삭제하기</el-button>-->
                    <button class="btn_remove"  @click="handleRemove()">삭제하기</button>

                    <!--  <button class="btn_up" size="small" type="primary">업로드하기</button>
                      <button class="btn_remove" size="small" type="success" @click="handleRemove()">삭제하기</button>-->
                    <div class="profile_info"> 105 x 105 사이즈에 최적화 되어있습니다.</div>

                </div>
            </div>
            <div class="input_error" v-if="validation.hasError('files')" v-html="validation.firstError('files')"></div>

            <div class="form_data">
                <div class="title">이름</div>
                <div class="input">
                    <input type="text" class="value" placeholder="이름을 입력주세요" v-model="name"
                           @input="setData('name', name)"
                           maxLength="5"></input>
                </div>
                <div class="input_error" v-if="validation.hasError('name')"
                     v-html="validation.firstError('name')"></div>
            </div>
            <div class="form_data">
                <div class="title">직업</div>
                <div class="input">
                    <input type="text" class="value" placeholder="직업을 입력해주세요" v-model="job" @input="setData('job', job)"
                           maxLength="20"></input>
                </div>
                <div class="input_error" v-if="validation.hasError('job')" v-html="validation.firstError('job')"></div>
            </div>
            <div class="form_data">
                <div class="title">생년월일</div>
                <div class="input">
                    <input type="text" class="value" placeholder="YYYY / MM / DD" v-model="birth"
                           @input="setData( 'birth',birth)"></input>
                </div>
                <div class="input_error" v-if="validation.hasError('birth')"
                     v-html="validation.firstError('birth')"></div>
            </div>
            <div class="form_data">
                <div class="title">휴대전화</div>
                <div class="input">
                    <input type="text" class="value" placeholder="숫자만 입력해주세요" v-model="phone"
                           @input="setData('phone', phone)"></input>
                </div>
                <div class="input_error" v-if="validation.hasError('phone')"
                     v-html="validation.firstError('phone')"></div>
            </div>
            <div class="form_data">
                <div class="title">이메일</div>
                <div class="input">
                    <input type="text" class="value" placeholder="이메일을 입력해주세요" v-model="email"
                           @input="setData('email', email)"></input>
                </div>
                <div class="input_error" v-if="validation.hasError('email')" v-html="validation.firstError('email')"></div>
            </div>
            <div class="form_data">
                <div class="title">주소</div>
                <el-select v-model="addr1" class="select" placeholder="지역1" @change="selectSi($event)">
                    <el-option :label="si.ac_si" :value="si.ac_idx" v-for="si in siList" :key="si.ac_idx"></el-option>
                </el-select>
                <el-select v-model="addr2" class="select" placeholder="지역2" :disabled="hasGu()">
                    <el-option :label="gu.ac_gu" :value="gu.ac_idx" v-for="gu in guList" :key="gu.ac_idx"></el-option>

                </el-select>
                <div class="input_error" v-if="validation.hasError('addr2')" v-html="validation.firstError('addr2')"></div>

                <!--            <div class="input_error" v-if="validation.hasError('name')" v-html="validation.firstError('name')"></div>-->
            </div>
            <div class="form_data introdu">
                <div class="title">자기소개</div>
                <div class="introduce">
                <textarea class="in_text" placeholder="자기소개를 입력해주세요" style="resize: none;" v-model="introduce"
                          @input="setData('introduce', introduce)"></textarea>
                </div>
                <div class="input_error ml0" v-if="validation.hasError('introduce')"
                     v-html="validation.firstError('introduce')"></div>
            </div>
          <div class="form_data mb15">
            <div class="title">추천인</div>
            <div  class="input">
            <input type="text" class="value" placeholder="추천인을 입력해주세요" v-model="recommender"
                   @input="setData('recommender', recommender)"></input>
            </div>
          </div>

            <div class="checkview mb20">
                <div class="checks">
                    <input id="agree" type="checkbox" :value="agree" @change="changeAgree()">
                    <label for="agree"> <span class="check_span">개인정보 취급방침에 동의합니다</span> </label>
                    <!--<input type="checkbox" name="privacy" id="privacy" :value="agree" @change="changeAgree()"></input>-->
                    <!--<label for="privacy">개인정보 취급방침에 동의합니다 </label>-->

                </div>
                <div class="regist_view" @click="openModal()">[약관보기]</div>
            </div>

        </div>
    </div>
</template>

<script>
    import util from "@/mixins/util"
    import memberValidator from "@/mixins/validators/memberValidator";
    import alertMixin from "@/mixins/alertMixin";
    import EventBus from "@/utils/event-bus";

    export default {
        name: "RegistComponent",
        mixins: [memberValidator, alertMixin],
        components: {},
        props: {},
        inject:['amidanSetData','checkAllValidator'],
        data() {
            return {
                imageMaxSize: 1024 * 1024 * 20,
                files: [],
                dialogImageUrl: '',
                addr1: '',
                addr2: '',
                siList: [],
                guList: [],
              recommender:''
            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {
            this.getSiList()
            EventBus.$on('runRegist', this.checkMemberValidator)
        },
        beforeDestroy() {
            EventBus.$off('runRegist')
        },
        destroyed() {
        },
        computed: {},
        methods: {
            onlyOnePhotoChange(file, fileList) {
                let maxSize = this.imageMaxSize;
                let type = file.raw.type.split('/');
                if (file.size > maxSize) {
                    this.errorAlert('1회 업로드 가능 용량을 초과했습니다!');
                    fileList.pop();
                } else if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                    this.errorAlert('이미지 파일만 업로드 가능합니다.')
                    fileList.pop();
                } else {
                    if (this.files.length > 0 && this.files[0].hasOwnProperty('a_idx') && this.files[0].a_idx != null) {
                        file.a_idx = this.files[0].a_idx;
                    }
                    file.org_url = file.url;
                    this.files[0] = file;
                    this.$forceUpdate();
                    this.setData('files', this.files);
                }
                this.dialogImageUrl = file.org_url;
            },
            setData(key, value) {
                this[key] = value;
            },

            handleRemove() {
                this.dialogImageUrl = ''
            },
            checkMemberValidator() {
                let validatorCheck = ['name', 'email', 'birth', 'job', 'addr2', 'introduce', 'files', 'agree']
                this.$validate(validatorCheck).then(success => {
                    if (!success) {
                        this.hasError = true;
                        this.checkAllValidator(true)
                        return false;
                    }
                    this.checkAllValidator(false)

                    this.memberRegist()
                })
            },
            getSiList() {
                let params = {si: 1}
                try {
                    this.$api.$area.getArea(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnAreaType(res.Info.type)
                        if (type === true) {
                            this.siList = res.List
                        } else {
                            this.errorAlert(type)
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            hasGu() {
                return util.isEmpty(this.guList)
            },
            getGuList(gu) {
                let params =
                    {
                        gu: gu
                    }
                try {
                    this.$api.$area.getArea(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnAreaType(res.Info.type)
                        if (type === true) {
                            this.guList = res.List
                        } else {
                            this.errorAlert(type)
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            selectSi(event) {
                this.getGuList(event)
                this.addr2 = ''
            },
            returnAreaType(type) {
                switch (type) {
                    case 1:
                        return true
                    default:
                        return '지역 리스트를 불러올 수 없습니다.'
                }
            },
            memberRegist() {
                let params = {
                    m_name: this.name,
                    m_email: this.email,
                    m_birth: this.inputBirth(this.birth),
                    m_hp: this.phone,
                    m_job: this.job,
                    m_memo: this.introduce,
                    ac_idx: this.addr2,
                    m_recommender:this.recommender
                }
                try {
                    this.$api.$member.applyMember(params).then(res => res.Data.Result).then(res => {
                        if (res.Info.type == 1) {
                            this.parentSetData('loading',true)
                            this.uploadFiles(this.files, 'mentor', res.List).then(() => {
                                this.createAlert({
                                    content: '가입신청이 완료되었습니다.',
                                    btnText: '확인',
                                    hide: () => {
                                        this.initForm()
                                        this.parentSetData('loading',false)
                                    }
                                })
                            })
                        } else {
                            this.errorAlert('가입신청이 실패하였습니다.')
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            uploadFiles(files, type, id) {
                return new Promise((resolve, reject) => {
                    let resultCnt = 0;
                    if (files.length === 0) {
                        resolve(true)
                    }
                    files.forEach((file, index) => {

                        if (file.hasOwnProperty('raw')) {
                            let formData = new FormData();
                            formData.append('files', file.raw);
                            formData.append('a_container_type', type);
                            formData.append('a_container_id', id);
                            if (file.hasOwnProperty('a_idx')) {
                                formData.append('a_idx', file.a_idx);
                            }
                            try {
                                this.$api.$file.createFile(formData).then(res => {
                                    resultCnt = resultCnt + 1;
                                    if (resultCnt === files.length) {
                                        resolve(true);
                                    }
                                })
                            } catch (e) {
                                console.log(e)
                            }
                        } else {
                            resultCnt = resultCnt + 1;
                        }
                    })
                })
            },
            changeAgree() {
                this.agree = !this.agree
            },
            inputBirth(value) {
                return this.$moment(value).format('YYYY-MM-DD')
            },
            openModal() {
                this.$modal.show('terms-modal', {termsType: 'stipulation'});
            },
            hasImage() {
                return !util.isEmpty(this.dialogImageUrl)
            },
            initForm(){
                this.files = []
                this.name = ''
                this.birth =''
                this.phone = ''
                this.email =''
                this.addr1=''
                this.addr2=''
                this.introduce=''
                this.recommender=''
                this.agree=false
            },
            parentSetData(key, value){
                this.amidanSetData(key, value)
            }
        },
        watch: {},
    }
</script>

<style lang="scss">
    .m_profile {
        width: 105px;
        height: 105px;
        border-radius: 50%;
    }

    .avatar-uploader {
        display: inline-block;
    }

    .form_data {
        .title {
            display: inline-block;
        }

        .input {
            display: inline-block;
        }
    }
</style>